var map = {
	"./betting_icon.embedded.svg": 1276,
	"./champions_league.embedded.svg": 1277,
	"./conmebol_icon.embedded.svg": 1278,
	"./csgo_icon.embedded.svg": 1279,
	"./dfs_icon.embedded.svg": 1280,
	"./dota2_icon.embedded.svg": 1281,
	"./dr_pepper.embedded.svg": 1282,
	"./dreamhack_icon.embedded.svg": 1283,
	"./esl_icon.embedded.svg": 1284,
	"./fifa.embedded.svg": 1285,
	"./fnatic_icon.embedded.svg": 1286,
	"./fortnite.embedded.svg": 1287,
	"./i_league_icon.embedded.svg": 1288,
	"./logo-12up.embedded.svg": 539,
	"./logo-90min.embedded.svg": 540,
	"./logo-dbltap.embedded.svg": 541,
	"./logo-ei.embedded.svg": 542,
	"./logo-floor8.embedded.svg": 543,
	"./logo-ftb90.embedded.svg": 544,
	"./logo-german_site.embedded.svg": 545,
	"./logo-ht_media.embedded.svg": 546,
	"./logo-pluralist.embedded.svg": 547,
	"./logo-theduel-mobile.embedded.svg": 548,
	"./logo-theduel.embedded.svg": 549,
	"./lol_icon.embedded.svg": 1289,
	"./mdl_icon.embedded.svg": 1290,
	"./melee_icon.embedded.svg": 1291,
	"./mlb_icon.embedded.svg": 1292,
	"./mls_icon.embedded.svg": 1293,
	"./nba_icon.embedded.svg": 1294,
	"./ncaa-basketball_icon.embedded.svg": 1295,
	"./ncaa-football_icon.embedded.svg": 1296,
	"./nfl_icon.embedded.svg": 1297,
	"./overwatch_icon.embedded.svg": 1298,
	"./powered-by-ei.embedded.svg": 550,
	"./powered-by-german_site.embedded.svg": 551,
	"./powered-by-ht_media.embedded.svg": 552,
	"./pubg.embedded.svg": 1299,
	"./smash4_icon.embedded.svg": 1300,
	"./streetfighter_icon.embedded.svg": 1301,
	"./suzuki_cup.embedded.svg": 1302,
	"./theduel-nav.embedded.svg": 1303,
	"./theduel_menu_icon.embedded.svg": 1304,
	"./world-cup.embedded.svg": 1305,
	"./yousport_icon.embedded.svg": 1306
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1318;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*\.embedded\.svg$
// module id = 1318
// module chunks = 15